import { ListItem } from 'components/List'
import * as React from 'react'
import { DisplayContent } from 'react-content-engine'

const HandLuggageSummary: React.FC = () => {
  return (
    <ListItem>
      <DisplayContent addNode contentKey="hand-luggage-summary">
        Hand luggage (standard)
      </DisplayContent>
    </ListItem>
  )
}

export default HandLuggageSummary
